var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorationIntroPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 732,
    viewBox: "0 0 1512 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_844)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip1_28_844)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 841.248,
    y: 506.381,
    width: 80.2262,
    height: 79.0801,
    fill: "#06000C",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1001.65,
    y: 576.06,
    width: 80.2262,
    height: 79.0801,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841.248,
    y: 92.3809,
    width: 80.2262,
    height: 79.0801,
    fill: "#06000C",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 921.277,
    y: 334.286,
    width: 80.2262,
    height: 79.0801,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 921.277,
    y: 576.06,
    width: 80.2262,
    height: 79.0801,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.474,
    y: 586.068,
    width: 80.2262,
    height: 80.2262,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.371,
    y: 505.381,
    width: 80.2262,
    height: 79.5062,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.371,
    y: 585.639,
    width: 80.2262,
    height: 80.0285,
    fill: "#020101",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.103,
    y: 326.957,
    width: 81.3723,
    height: 82.5184,
    fill: "#3D2851"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.73,
    y: 246.73,
    width: 81.3723,
    height: 80.2262,
    fill: "#3D2851"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.73,
    y: 326.957,
    width: 81.3723,
    height: 82.5184,
    fill: "#3D2851"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.927,
    y: 166.504,
    width: 81.3723,
    height: 80.2262,
    fill: "#06000C",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932,
    y: 614,
    width: 80.2262,
    height: 81.3723,
    fill: "#3D2851"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 640.644,
    x2: 1471.58,
    y2: 640.644,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 317.906,
    x2: 1471.58,
    y2: 317.906,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 479.274,
    x2: 1471.58,
    y2: 479.274,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 156.536,
    x2: 1471.58,
    y2: 156.536,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 559.959,
    x2: 1471.58,
    y2: 559.959,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 237.221,
    x2: 1471.58,
    y2: 237.221,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 398.589,
    x2: 1471.58,
    y2: 398.589,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 721.329,
    x2: 1471.58,
    y2: 721.329,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 75.8506,
    x2: 1471.58,
    y2: 75.8506,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.27529,
    y1: -33.1987,
    x2: 7.27524,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.756,
    y1: -33.1987,
    x2: 652.756,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.016,
    y1: -33.1989,
    x2: 330.016,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 975.492,
    y1: -33.1987,
    x2: 975.492,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1298.23,
    y1: -33.1987,
    x2: 1298.23,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.645,
    y1: -33.1987,
    x2: 168.645,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 814.122,
    y1: -33.1987,
    x2: 814.122,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.386,
    y1: -33.1987,
    x2: 491.386,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1136.86,
    y1: -33.1989,
    x2: 1136.86,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1459.6,
    y1: -33.1987,
    x2: 1459.6,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9626,
    y1: -33.1987,
    x2: 87.9625,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 733.439,
    y1: -33.1989,
    x2: 733.439,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.699,
    y1: -33.1987,
    x2: 410.698,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1056.18,
    y1: -33.1987,
    x2: 1056.18,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1378.92,
    y1: -33.1987,
    x2: 1378.92,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.333,
    y1: -33.1987,
    x2: 249.333,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 894.809,
    y1: -33.1987,
    x2: 894.809,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 572.069,
    y1: -33.1987,
    x2: 572.069,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1217.55,
    y1: -33.1987,
    x2: 1217.54,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 732,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28_844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1365,
    height: 720,
    fill: "white",
    transform: "translate(518 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationIntroPurple);
export default __webpack_public_path__ + "static/media/decorationIntroPurple.97b718597dc3ee46a25c40f9454bb91d.svg";
export { ForwardRef as ReactComponent };